

import { useEffect } from "react";
import { useNavigate } from "react-router";

export const AuthGurad = ({ children }) => {
  const navigate = useNavigate();
  const rawUser = localStorage.getItem("user");
  const user = rawUser ? rawUser : null;

  useEffect(() => {
    if (!user) {
      navigate("/login");
    }
  }, [user, navigate]);

  return user ? children : null;
};
